module.exports = __webpack_public_path__ + "img/white-cam-1.977ea042.png";